import moment from 'moment';
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { isIOS } from 'react-device-detect';
import { TYPE } from "../constant";
import {
  starAuthAPI,
  starShopHistoryAPI,
  starShopHistoryCntAPI,
  starSaveUpAPI
} from '../api/starShopAPI';
import { Base64Encode, getUserAgent, openStarShop, openWebBrowser } from "../utils/utilityEtc";
import { useAlert, useApiLogData, useLocalStorage, useUserInfo } from ".";

export default function useStarShop() {
  const { info } = useUserInfo();
  const [Alert] = useAlert();
  const { userData, setUserData } = useLocalStorage();
  const { setApiLogData } = useApiLogData();

  const [totalCnt, setCnt] = useState(0);
  const [isSave, setSave] = useState(false);
  const [historyList, setHistory] = useState(null);

  const deviceInfo = useSelector(state => state.deviceInfo);
  
  // 별보상 인증
  const starAuthAPICall = useCallback( async (cntrtNo) => {
    if (!cntrtNo) return;
    /**
     * token 조회 에러 시 총 3번을 시도
     */
    let result = await starAuthAPI(cntrtNo);
    if (result.status !== 201) {
      if (process.env.REACT_APP_ENV !== 'production') return;
      setApiLogData({ 
        req: result.req,
        res: JSON.stringify(result.res),
        resCd: result.status,
        param: { param1: cntrtNo },
        apiUrl: result.url,
        userKey: cntrtNo 
      });
      result = await starAuthAPI(cntrtNo);
      if (result.status !== 201) {
        if (process.env.REACT_APP_ENV !== 'production') return;
        setApiLogData({ 
          req: result.req,
          res: JSON.stringify(result.res),
          resCd: result.status,
          param: { param1: cntrtNo },
          apiUrl: result.url,
          userKey: cntrtNo  
        });
        result = await starAuthAPI(cntrtNo);
        if (result.status !== 201) {
          if (process.env.REACT_APP_ENV !== 'production') return;
          setApiLogData({ 
            req: result.req,
            res: JSON.stringify(result.res),
            resCd: result.status,
            param: { param1: cntrtNo },
            apiUrl: result.url,
            userKey: cntrtNo  
          });
        }
      }
    }
  }, [info]);

  // 별보상 총 카운트
  const starCntAPI = useCallback(async () => {
    if (!info || !info.cntrtNo || !info.learnerCode) return;

    const { cntrtNo, learnerCode } = info;
    const resp = await starShopHistoryCntAPI({
      CONSTRACT_NUMBER: cntrtNo,
      // CONSTRACT_NUMBER: "testtt",
      CUSTOMER_NUMBER: learnerCode,
      SERVICE_CD: process.env.REACT_APP_ENV === 'production' ? 'KBRS01' : 'KBRS02'
    });

    if (resp?.status === 200) {
      setCnt(resp.total.TOT_CNT);
    } else {
      if (process.env.REACT_APP_ENV !== 'production') return;
      setApiLogData({
        req: resp.req,
        res: resp.res,
        resCd: resp.status,
        apiUrl: resp.url
      });
    }

  }, []);

  // 별보상 히스토리
  const starHistoryAPICall = useCallback(async (page) => {
    if (!info || !info.cntrtNo || !info.learnerCode) return;
    const { cntrtNo, learnerCode } = info;
    const resp = await starShopHistoryAPI({
      CONSTRACT_NUMBER: cntrtNo,
      CUSTOMER_NUMBER: learnerCode,
      SERVICE_CD: process.env.REACT_APP_ENV === 'production' ? 'KBRS01' : 'KBRS02'
    }, {
      IN_PAGESIZE:10,
      IN_PAGENUM: page ? page : 1
    });

// console.log({ resp });
    if (resp && resp.status === 200) {
      setHistory(resp.result);
    } else {
      if (process.env.REACT_APP_ENV !== 'production') return;
      setApiLogData({
        req: resp.req,
        res: resp.res,
        resCd: resp.status,
        apiUrl: resp.url,
        param: { param1: resp.param1 }
      });
    }
  }, [info]);

  // 별보상 적립
  const starSaveUpAPICall = useCallback(async (stgNm) => {
    if (userData.star === moment(new Date()).format('YYYYMMDD')) return;
    if (!info || !info.cntrtNo || !info.learnerCode) return;
    const { cntrtNo, learnerCode, learnerId } = info;

    const params = Base64Encode(JSON.stringify({
      "MENU_CD":"",
      "RWRD_STNR_GRP_CD": learnerId,
      "RWRD_STNR_DTL_SEQ": moment().format("YYYYMMDD"),
      "DTL_POLICY_01":"",
      "DTL_POLICY_02":"",
      "DTL_POLICY_03":"",
      "DTL_POLICY_04":"",
      "DTL_POLICY_05":"",
      "DTL_CNTT_01": stgNm ? stgNm : '',
      "DTL_CNTT_02":"",
      "DTL_CNTT_03":"",
      "DTL_CNTT_04":"",
      "DTL_CNTT_05":""
      }));

    const resp = await starSaveUpAPI({
      CONSTRACT_NUMBER: cntrtNo,
      CUSTOMER_NUMBER: learnerCode,
      REWARD_AUTH_CD: process.env.REACT_APP_ENV === 'production' ? '01' : '02',
      SERVICE_CD: 'KBRS'
    }, params);

    if (resp && resp.status === 200) {
      if (resp.result === 'Y') {
        setSave(true);
        setUserData({ star: moment(new Date()).format('YYYYMMDD') });
      } else if (resp.result === 'D') {
        setUserData({ star: moment(new Date()).format('YYYYMMDD') });
      }
    } else {
      if (process.env.REACT_APP_ENV !== 'production') return;
      setApiLogData({
        req: resp.req,
        res: resp.res,
        resCd: resp.status,
        apiUrl: resp.url,
        param: { param1: resp.param1 }
      });
    }

  }, [info])


  // 스타샵으로 이동
  const handleStarShopOpen = useCallback(() => {
    if (!info || !info.cntrtNo || !info.learnerCode) return;
    
    const { cntrtNo, learnerCode } = info;
    if (deviceInfo.type === TYPE.DEVICE.PC) {
      window.open(`${process.env.REACT_APP_STAR_SHOP_URL}/index.html?contractNumber=${cntrtNo}&customerNumber=${learnerCode}&type=smartthink`);
    } else {
      // console.log({ cntrtNo, learnerCode });
      try {
        if (isIOS) {
          openStarShop(cntrtNo, learnerCode, '');
          return;
        }

        const version = getUserAgent('VERSION_NAME');
        if (version) {
          if (Number(version.replace(/\./gi, '')) < 115) {
            Alert(
              "원활한 서비스를 위해<br/>앱을 최신버전으로 업데이트 해주세요.",
              () => {
                openWebBrowser("https://play.google.com/store/apps/details?id=com.wjthinkbig.barosem");
              }
            )
          } else {
            openStarShop(cntrtNo, learnerCode, '');
          }
        }
      } catch (error) {
        console.log("### window.aicalculator.openStarShop error: ", error);
      }
    }
  }, [info, deviceInfo])

  return {
    totalCnt,
    historyList,
    isSave,
    setSave,
    starCntAPI,
    starAuthAPICall,
    starHistoryAPICall,
    starSaveUpAPICall,
    handleStarShopOpen
  }
}